/**
 * GED-specific CMG constants. Every formula is shared with the Person (AV)
 * care type — see cmgCalculationsShared.js. GED differs only by its per-child-age
 * social-contribution ceiling below.
 */
import {
  CMG_EFFORT_RATE_HOURLY,
  CMG_HOURLY_WAGE_REFERENCE,
  computeSocialContributionsCredit,
} from './cmgCalculationsShared'

export {
  computeGrossForSimpleAndSharedHours,
  computeEmployerContributionsReductionCost,
  computeEmployerContributionsReduction,
  computeCreditTaxCeil as computeGedCreditTaxCeil,
  computeTaxesCredit as computeGedTaxesCredit,
  computeAmountLeftPayableBeforeTaxes as computeGedAmountLeftPayableBeforeTaxes,
  computeAmountLeftPayable as computeGedAmountLeftPayable,
  computeTotalAmount as computeGedTotalAmount,
} from './cmgCalculationsShared'

export const GED_EFFORT_RATE_HOURLY = CMG_EFFORT_RATE_HOURLY

export const GED_HOURLY_WAGE_REFERENCE = CMG_HOURLY_WAGE_REFERENCE

export const GED_SOCIAL_CONTRIBUTION_MAX_BY_CHILD_AGE = {
  1: 520,
  2: 261,
  3: 0,
  4: 0,
}

export function computeGedSocialContributionsCredit(args) {
  return computeSocialContributionsCredit({
    ...args,
    socialContributionMaxByChildAge: GED_SOCIAL_CONTRIBUTION_MAX_BY_CHILD_AGE,
  })
}
